// extracted by mini-css-extract-plugin
module.exports = {"root":"musicianPlayer_root__3oPWj","infoContainer":"musicianPlayer_infoContainer__1TuO_","title":"musicianPlayer_title__2-SmO","description":"musicianPlayer_description__1wuOd"};